// bundleCategoryCogsUrl.ts — pure serialize/deserialize of a CogsRangeValue across the four
// bc-prefixed URL params the Bundle Categories tab persists (bccogsmin, bccogsmax, bccogsnone,
// bccogspartial). Kept separate from BundleCategoryManager so the URL round-trip is unit-testable
// without rendering the page. Defaults are dropped from the URL (null) to match how the tab's
// other filters serialize.

import { CogsRangeValue } from '../components/common/CogsRangeFilter';

// The raw string values read from the four URL params (via useUrlParam, which defaults the
// booleans to 'false' and the numeric bounds to '').
export interface BcCogsParams {
    min: string;
    max: string;
    none: string;
    partial: string;
}

// The write shape handed to setUrlParams — each key either carries its serialized value or null
// (drop it from the URL) when it equals its default.
export interface BcCogsParamUpdate {
    bccogsmin: string | null;
    bccogsmax: string | null;
    bccogsnone: string | null;
    bccogspartial: string | null;
}

// Deserialize the four URL params back into a CogsRangeValue for <CogsRangeFilter>.
export const cogsFilterFromParams = ({ min, max, none, partial }: BcCogsParams): CogsRangeValue => ({
    min: min || '',
    max: max || '',
    none: none === 'true',
    partialOnly: partial === 'true',
});

// Serialize a CogsRangeValue into the URL-param write shape, dropping each key (null) when it is
// at its default so defaults never clutter the URL — mirrors setFilterParam for the other filters.
export const cogsFilterToParams = (v: CogsRangeValue): BcCogsParamUpdate => ({
    bccogsmin: v.min !== '' ? v.min : null,
    bccogsmax: v.max !== '' ? v.max : null,
    bccogsnone: v.none ? 'true' : null,
    bccogspartial: v.partialOnly ? 'true' : null,
});
